/* from spinkit: https://tobiasahlin.com/spinkit/ */

.preloader {
  width: 42px;
  height: 42px;
}
.preloader-cube {
  width: 14px;
  height: 14px;
  background-color: #333;
  float: left;
}
.animate {
  animation: preloader-cubeGridScaleDelay infinite ease-in-out;
}

@-webkit-keyframes preloader-cubeGridScaleDelay {
  0%,
  70%,
  100% {
    -webkit-transform: scale3D(1, 1, 1);
    transform: scale3D(1, 1, 1);
  }
  35% {
    -webkit-transform: scale3D(0, 0, 1);
    transform: scale3D(0, 0, 1);
  }
}

@keyframes preloader-cubeGridScaleDelay {
  0%,
  70%,
  100% {
    -webkit-transform: scale3D(1, 1, 1);
    transform: scale3D(1, 1, 1);
  }
  35% {
    -webkit-transform: scale3D(0, 0, 1);
    transform: scale3D(0, 0, 1);
  }
}
